module.exports = __webpack_public_path__ + "media/images/webinar-2-1f301fff19e2df54b973792219d7f9d9.jpg";